import React, { useState } from 'react';
import { Grid, Box, Button, Divider } from '@mui/material';
import { AutoComplete } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
	AddSearchFlightDispatch,
	fetchCityDispatch,
} from '../../reducers/HomeReducer';
import { DatePicker } from 'antd';
import moment from 'moment';
import {
	setSelectedArrival,
	setSelectedDepart,
} from '../../reducers/UiReducer';
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';
const Option = AutoComplete.Option;
const { RangePicker } = DatePicker;

const SearchEngineFlight = () => {
	const dispatch = useDispatch();
	const { city } = useSelector((state) => state.home);
	const { depart, arrival, tab } = useSelector((state) => state.ui);
	const [departDate, setDepartDate] = useState('');
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);
	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [loading, setLoading] = useState(false);
	const [infant, setInfant] = useState(0);
	const [departDateReturn, setDepartDateReturn] = useState('');
	const handleChange = (value) => {
		let values = value.toLowerCase();
		let cityData = {
			keywords: values,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
		dispatch(setSelectedDepart(values));
	};
	const opsList =
		city?.result?.length > 0 &&
		city.result?.map((l) => {
			return (
				<Option
					value={`${l.airport_code} - ${l.city_name},${l.country_code}`}>{`${l.airport_code} - ${l.city_name} , ${l.country_name}`}</Option>
			);
		});
	const handleChange2 = (value) => {
		let values = value.toLowerCase();
		let cityData = {
			keywords: values,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
		dispatch(setSelectedArrival(values));
	};
	const opsList2 =
		city?.result?.length > 0 &&
		city.result?.map((l) => {
			return (
				<Option
					value={`${l.airport_code} - ${l.city_name},${l.country_code}`}
					onChange={() =>
						console.log('a', l)
					}>{`${l.airport_code} - ${l.city_name} , ${l.country_name}`}</Option>
			);
		});
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDate(dateString);
	};
	const onChangeReturn: DatePickerProps['onChange'] = (date, dateString) => {
		console.log('date', dateString);
		setDepartDateReturn(dateString);
	};
	const showModal = () => {
		setOpen(true);
	};
	const handleCancel = () => {
		setOpen(false);
	};
	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};
	const handleSearch = () => {
		let formData = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 1,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: depart.split(' ')[0],
					Destination: arrival.split(' ')[0],
					FlightCabinClass: 1,
					PreferredDepartureTime: departDate,
				},
			],
			Sources: 'WEB',
			agent_id: 0,
		};
		let formData2 = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 2,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: depart.split(' ')[0],
					Destination: arrival.split(' ')[0],
					FlightCabinClass: 1,
					PreferredDepartureTime: departDateReturn[0],
				},
				{
					Origin: arrival.split(' ')[0],
					Destination: depart.split(' ')[0],
					FlightCabinClass: 1,
					PreferredDepartureTime: departDateReturn[1],
				},
			],
			Sources: 'WEB',
			agent_id: 0,
		};
		if (tab === 'oneway') {
			navigate('/searchresult', { state: formData });
			dispatch(AddSearchFlightDispatch(formData, navigate));
		} else {
			navigate(
				depart?.split(',')[1].toUpperCase() === 'IN' &&
					arrival?.split(',')[1].toUpperCase() === 'IN'
					? '/searchresultroundtrip'
					: '/searchresultinternational',
				{ state: formData2 }
			);
			dispatch(AddSearchFlightDispatch(formData2, navigate));
		}
	};
	return (
		<Grid container spacing={1}>
			<Grid item xs={12} sm={12} md={3} lg={3}>
				<AutoComplete
					style={{ width: '100%' }}
					dropdownMenuStyle={{
						maxHeight: 1000,
						overflowY: 'visible',
					}}
					placeholder='From'
					onClick={(e) => console.log('val', e.target.value)}
					onChange={handleChange}>
					{opsList}
				</AutoComplete>
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={3}>
				<AutoComplete
					style={{ width: '100%' }}
					dropdownMenuStyle={{
						maxHeight: 1000,
						overflowY: 'visible',
					}}
					placeholder='To'
					onChange={handleChange2}>
					{opsList2}
				</AutoComplete>
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={tab === 'oneway' ? 2 : 3}>
				{tab === 'oneway' ? (
					<DatePicker
						disabledDate={disabledDate}
						onChange={onChange}
						// format='DD-MMYYYY'
						style={{ width: '100%', padding: 8 }}
					/>
				) : (
					<RangePicker
						disabledDate={disabledDate}
						style={{ width: '100%', padding: 8 }}
						onChange={onChangeReturn}
					/>
				)}
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={2}>
				<Button
					onClick={showModal}
					style={{
						textTransform: 'capitalize',
						padding: 7,
						border: '1px solid lightgrey',
						width: '100%',
					}}>
					Traveller Class
				</Button>{' '}
				<hr />
				<Modal
					open={open}
					title='Travellers'
					onOk={handleOk}
					onCancel={handleCancel}
					footer={[
						<Button key='back' onClick={handleCancel}>
							OK
						</Button>,
					]}>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
						}}>
						<p>Adults(12+yrs)</p>
						<Box>
							<Button
								onClick={() => (adult === 0 ? '' : setAdult(adult - 1))}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								--
							</Button>
							<Button
								style={{
									fontSize: 14,
									background: 'white',
									fontWeight: 'bold',
								}}>
								{adult}
							</Button>
							<Button
								onClick={() =>
									adult + child + infant === 9 ? adult : setAdult(adult + 1)
								}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								+
							</Button>
						</Box>
					</Box>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							marginTop: 5,
						}}>
						<p>Child(2-11yrs)</p>
						<Box>
							<Button
								onClick={() => (child === 0 ? '' : setChild(child - 1))}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								--
							</Button>
							<Button
								style={{
									fontSize: 14,
									background: 'white',
									fontWeight: 'bold',
								}}>
								{child}
							</Button>
							<Button
								onClick={() =>
									adult + child + infant === 9 ? child : setChild(child + 1)
								}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								+
							</Button>
						</Box>
					</Box>
					<Box
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							marginTop: 5,
						}}>
						<p>Infant(0-2yrs)</p>
						<Box>
							<Button
								onClick={() => (infant === 0 ? '' : setInfant(infant - 1))}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								--
							</Button>
							<Button
								style={{
									fontSize: 14,
									background: 'white',
									fontWeight: 'bold',
								}}>
								{infant}
							</Button>
							<Button
								onClick={() =>
									adult + child + infant === 9 ? infant : setInfant(infant + 1)
								}
								style={{
									fontSize: 14,
									background: 'orange',
									color: 'white',
									fontWeight: 'bold',
								}}>
								+
							</Button>
						</Box>
					</Box>
				</Modal>
			</Grid>
			<Grid item xs={12} sm={12} md={3} lg={tab === 'oneway' ? 2 : 1}>
				<Button
					onClick={handleSearch}
					variant='contained'
					style={{
						width: '100%',
						background: 'orange',
						fontWeight: 'bold',
						padding: '7px',
					}}>
					Search
				</Button>
			</Grid>
		</Grid>
	);
};

export default SearchEngineFlight;
